import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import Links from '@components/ncFiles/components/links';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsNCFileLinksProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const JobDetailsNCFileLinksComponent: FC<JobDetailsNCFileLinksProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  ncFileData,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    getAllNcFiles: true,
  });

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <Links isLoading={!ncFileData.wasLoaded} links={ncFileData?.data?.links ?? []} />
    </JobContentWrapper>
  );
};

const JobDetailsNCFileLinks = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFileLinksComponent);

export { JobDetailsNCFileLinks };
